module.exports = __webpack_public_path__ + "media/src/application/media/help_3-023260ce2b887f4f5ddbe9c7aed56a38.jpg";